<template>
  <div>
    <div
      class="service-apply-result"
      v-if="this.bookingInfo.payStatus !== undefined"
    >
      <div v-if="paySuccess">
        <img
          src="~@/assets/images/success.svg"
          v-if="this.bookingInfo.payStatus === 10"
        />
        <img src="~@/assets/images/processing.svg" v-else />
        <div class="service-apply-result-text">
          {{ `${serviceName} ${bookingStatus}` }}<br />
          {{ recordInfo.applyTime }}
        </div>
        <div class="service-apply-result-detail">
          {{ `訂單編號：${recordInfo.orderId}` }}
        </div>
      </div>
      <div v-else>
        <img src="~@/assets/images/failure.svg" />
        <div class="service-apply-result-text">
          {{ `${serviceName} 申請失敗` }}<br />
          {{ recordInfo.applyTime }}
        </div>
        <div class="service-apply-result-detail">
          付款失敗
        </div>
      </div>
    </div>
    <div class="service-apply-result" v-else>
      <img src="~@/assets/images/processing.svg" />
      <div class="service-apply-result-text">
        {{ `${serviceName} 資料查詢中` }}
      </div>
    </div>
    <div class="banquet-apply-title banquet-section-title">申請人</div>
    <inputField
      id="name"
      label="姓名"
      :disabled="true"
      class="banquet-name"
      :value="recordInfo.applyName | securityHidden('Ｏ', 1, 1)"
    />
    <inputField
      id="phone"
      label="手機號碼/聯絡電話"
      :disabled="true"
      class="banquet-phone"
      :value="recordInfo.applyPhone | securityHidden('*', 3, 0)"
    />

    <div v-if="bookingInfo.serviceType === 0">
      <div class="banquet-check">
        <inputField
          id="numberOfPeople"
          label="葷食人數"
          :disabled="true"
          class="banquet-count"
          :value="bookingInfo.reposeOrderInfo.headQuantity"
        />
        <inputField
          id="numberOfVegetarian"
          label="素食人數"
          :disabled="true"
          class="banquet-vegetable-count"
          :value="bookingInfo.reposeOrderInfo.vegetarian"
        />
      </div>
    </div>
    <div v-else-if="bookingInfo.serviceType === 1">
      <div class="clear-div" />

      <div class="light-line" />

      <personInfo
        v-for="(item, index) in bookingInfo.prayerList"
        :key="index"
        :prayerInfo="item"
        :prayerIndex="index"
        :totalCount="bookingInfo.prayerList.length"
        :lightInfo="lightInfo"
        :givewayInfo="givewayInfo"
        :disabled="true"
        :isRecord="true"
      >
      </personInfo>

      <div class="light-line" />
    </div>
    <div v-if="givewayInfo.givewayName" class="banquet-section-title">贈品</div>
    <div v-if="givewayInfo.givewayName" style="margin: 10px 0 0 0">
      {{ givewayInfo.givewayName }}
    </div>
    <div v-if="givewayInfo.givewayName" style="margin: 10px 0 0 0">
      {{ `贈品寄送地址：${givewayAddressInfo}` }}
    </div>
    <div v-if="givewayInfo.givewayName" class="banquet-seperator-line" />
    <div
      v-if="bookingInfo.serviceType === 0"
      class="banquet-apply-info-line banquet-seperator-line"
    />
    <div class="banquet-section-title">費用總計</div>
    <inputField
      id="banquet-fee"
      label="費用總計"
      :disabled="true"
      class="banquet-fee"
      :value="displayFee"
    />
    <div class="banquet-seperator-line" />
    <div class="banquet-section-title">付款方式</div>
    <inputField
      id="banquet-pay-way"
      label="選擇付款方式"
      :disabled="true"
      class="banquet-pay-way"
      value="LINE Pay"
    ></inputField>

    <div class="service-record-notice" v-if="bookingInfo.serviceType === 0">
      注意事項：<br />
      <br />
      -
      平安宴線上登記之座位恕無法挑選，桌號位置盡可能以整桌排序，不滿一桌之人數或分別採線上及現場報名之家人朋友可能無法比鄰而坐，敬請見諒<br />
      <br />
      - 線上報名繳費完成後，於7日內將會收到系統寄發之桌次簡訊通知，敬請留意。<br />
      <br />
      -
      線上報名者欲參加擲筊大賽，請於活動當日最遲8點前至文衡殿櫃檯服務處憑簡訊兌換擲筊單。<br />
      <br />
      - 若遲未收到簡訊通知或桌次有任何疑問，請電洽TEL: (06)594-0050<br />
      <br />
    </div>
    <div
      class="service-record-notice"
      v-else-if="bookingInfo.serviceType === 1"
    ></div>
    <div class="record-previous-step">
      <div class="temple-button-text" @click="clickPrevious">
        回上一頁
      </div>
      <div
        class="temple-button-text record-continue-pay"
        @click="clickPay"
        v-if="
          this.bookingInfo.payStatus === 0 || this.bookingInfo.payStatus === 1
        "
      >
        進行付款
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import store from 'Store/store';
import inputField from 'Components/inputField/inputField.vue';
import formater from 'Core/format.js';
import personInfo from 'Pages/ServiceModule/ServiceLight/ServiceLightPersonInfo.vue';

export default {
  name: 'ServiceRecordStep3',
  components: {
    inputField,
    personInfo,
  },
  data() {
    return {};
  },
  props: {
    recordInfo: {},
  },
  mounted() {
    window.scrollTo({ behavior: 'auto', top: 0 });
  },
  methods: {
    clickPrevious() {
      this.$emit('previousStep');
    },
    clickPay() {
      window.location.href = this.bookingInfo.paymentUrls.web;
    },
  },
  computed: {
    serviceName() {
      switch (this.bookingInfo.serviceType) {
        case 0:
          return '平安宴';

        case 1:
          return '線上點燈';

        default:
          return '';
      }
    },
    bookingStatus() {
      switch (this.bookingInfo.payStatus) {
        case 0:
        case 1:
          return '等待付款中';

        case 10:
          return '申請成功';

        default:
          return '申請失敗';
      }
    },
    bookingInfo() {
      return store.state.main.bookingInfo;
    },
    displayFee() {
      return `${formater.thousandComma(Number(this.bookingInfo.price))}元`;
    },
    paySuccess() {
      return (
        this.bookingInfo.payStatus === 1 ||
        this.bookingInfo.payStatus === 0 ||
        this.bookingInfo.payStatus === 10
      );
    },
    givewayAddressInfo() {
      if (
        this.givewayInfo.givewayAddress.county &&
        this.givewayInfo.givewayAddress.town &&
        this.givewayInfo.givewayAddress.detail
      ) {
        return (
          this.givewayInfo.givewayAddress.county +
          Vue.filter('securityHidden')(
            this.givewayInfo.givewayAddress.town,
            'O',
            1,
            0
          ) +
          Vue.filter('securityHidden')(
            this.givewayInfo.givewayAddress.detail,
            'O',
            0,
            0
          )
        );
      }

      return '現場領取';
    },

    lightInfo() {
      var lightInfoList = [];
      lightInfoList = store.state.main.onlineStatus.lightInfo.lightList.map(
        (light) => {
          return {
            text: light.name,
            value: light.type,
            price: light.price,
            remainingAmount: light.remainingAmount,
            disabled: light.remainingAmount <= 0 ? true : false,
          };
        }
      );
      return lightInfoList;
    },

    // givewayInfo() {
    //   var givewayList = [];
    //   givewayList = store.state.main.onlineStatus.lightInfo.givewayNames.map(
    //     (giveway) => {
    //       return {
    //         text: giveway,
    //         value: giveway,
    //       };
    //     }
    //   );
    //   return givewayList;
    // },
    givewayInfo() {
      if (!this.bookingInfo.prayerList) {
        return {
          givewayName: '',
          givewayAddress: {
            county: '',
            town: '',
            detail: '',
          },
        };
      }
      return this.bookingInfo.prayerList[0];
    },
  },
};
</script>

<style scoped>
.record-previous-step {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}
.banquet-result {
  margin: 0px 5px 0px 5px;
}

.service-apply-result {
  margin: 30px 0px 32px 0px;
  align-items: center;
  text-align: center;
}

.service-apply-result-text {
  margin: 10px 0px 5px 0px;
  font-size: 14px;
  color: #000000;
}

.service-apply-result-detail {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

/* .banquet-check {
  margin: 0px 5px 0px 5px;
} */

.banquet-section-title {
  font-size: 16px;
  font-weight: bold;
  color: #b18147;
}

.banquet-apply-title {
  margin-top: 50px;
}

.banquet-name,
.banquet-phone,
.banquet-count,
.banquet-vegetable-count,
.banquet-fee,
.banquet-pay-way {
  margin-top: 10px;
}

.banquet-seperator-line {
  margin: 50px 0px 50px 0px;
  height: 1px;
  background-color: #000000;
}

.service-record-notice {
  margin: 66px 5px 0px 5px;
  font-size: 16px;
}
.clear-div {
  display: grid;
  width: 100%;
}
.light-line {
  margin: 50px 0px 50px 0px;
  width: 100%;
  border-top: 1px solid;
  border-color: black;
}

.record-continue-pay {
  margin-left: 30px;
}

@media (min-width: 768px) {
  .banquet-name,
  .banquet-phone,
  .banquet-count,
  .banquet-vegetable-count,
  .banquet-fee,
  .banquet-pay-way {
    width: calc(50% - 20px);
  }

  .banquet-name,
  .banquet-count {
    float: left;
  }

  .banquet-phone,
  .banquet-vegetable-count {
    float: right;
  }

  .banquet-apply-info-line {
    margin-top: 230px;
  }

  .service-apply-result-detail {
    margin-top: 20px;
  }
}
</style>
